import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class TitleWithBadge extends Vue {
    @Prop({ type: String, default: '' }) public title: string;
    @Prop({ type: String, default: '' }) public badge: string;
    @Prop({ type: String, default: 'primary' }) public color: string;
}
